import React from 'react';
import RoomBreakdown from '../containers/RoomBreakdown';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import {LocalDate, convert, nativeJs, DateTimeFormatter, ChronoUnit} from 'js-joda';
import * as AppDimensions from '../constants/AppDimensions';
import * as firebase from 'firebase'

class SearchBarComponent extends React.Component {

  constructor(props) {
    super(props);

    const today = LocalDate.now();
    const tomorrow = LocalDate.now().plusDays(1);

    this.state = {
      nights: AppDimensions.noOfNights,
      today: today,
      tomorrow: tomorrow,
      startDate: this.localDateToDate(this.localDateFromString(this.props.criteria.startDate)),
      endDate: this.localDateToDate(this.localDateFromString(this.props.criteria.endDate)),
      disableYearSelection: false
    }
  }

  componentWillMount() {
    this.props.onCustomerRequest();
    const onCustomerChange = this.props.onCustomerChange;
    const onCheckAvailClick = this.props.onCheckAvailClick;
    const criteria = this.props.criteria;
    const customer_key = this.props.customer_key;

    firebase.auth().onAuthStateChanged(user => {

      firebase.auth().currentUser.getIdToken().then(token => {

        if (user) { // signed in successfully
          let customerData = firebase.functions().httpsCallable(
              'retrieveCustomer');
          customerData({customer_key: customer_key, token: token, dev: false}).then(
              function (result) {
                // Read result of the Cloud Function.
                let customerForKey = firebase.database().ref('customers').orderByKey().equalTo(customer_key);
                customerForKey.once('value', snapshot => {
                  snapshot.forEach( childSnapshot => {
                    let childKey = childSnapshot.key;
                    let customerData = childSnapshot.val();

                    onCustomerChange(customerData, result.data.token);
                    onCheckAvailClick(criteria, customerData.api_url, result.data.token);
                  });
                });
              });
        }
        else {
          // user is signed out
        }
      });
    });

    // firebase.auth().onAuthStateChanged(user => {
    //
    //   firebase.auth().currentUser.getIdToken().then(token => {
    //
    //     if (user) { // signed in successfully
    //       let customerData = firebase.functions().httpsCallable(
    //           'retrieveCustomer');
    //       customerData({customer_key: this.props.customer_key, token: token}).then(
    //           function (result) {
    //             // Read result of the Cloud Function.
    //             onCustomerChange(result.data.customerData, result.data.token);
    //             onCheckAvailClick(criteria, result.data.customerData.api_url, result.data.token);
    //           });
    //     }
    //     else {
    //       // user is signed out
    //     }
    //   });
    // });

    // firebase.auth().onAuthStateChanged(user => {
    //   if(user) { // signed in successfully
    //     let customerForKey = firebase.database().ref('customers').orderByKey().equalTo(this.props.customer_key);
    //
    //     customerForKey.once('value', snapshot => {
    //       snapshot.forEach( childSnapshot => {
    //         let childKey = childSnapshot.key;
    //         let customerData = childSnapshot.val();
    //
    //         this.props.onCustomerChange(customerData);
    //         this.props.onCheckAvailClick(this.props.criteria, customerData.api_url);
    //       });
    //     });
    //   }
    //   else {
    //     // user is signed out
    //   }
    // });

    // this.props.onCheckAvailClick(this.props.criteria);
  }

  handleChangeStartDate = (event, date) => {
    let endDate = this.localDateFromDate(date).plusDays(this.state.nights);
    let criteria = {...this.props.criteria, startDate: this.formatNativeDate(date), endDate: this.localDateToString(endDate)};
    this.props.onCriteriaChange(criteria);
    this.setState({startDate : date, endDate: this.localDateToDate(endDate)});
    this.props.onCheckAvailClick(criteria, this.props.customer.api_url, this.props.token);
  };

  handleChangeEndDate = (event, date) =>  {
    let startDate = this.localDateFromString(this.props.criteria.startDate);
    let endDate = this.localDateFromDate(date);
    let nights = startDate.until(endDate, ChronoUnit.DAYS);

    this.props.onCriteriaChange(
        {...this.props.criteria, endDate: this.formatNativeDate(date)});

    this.setState({endDate : date, nights: nights})
  };

  handleNightsChange(event) {
    if (event.target.value !== undefined) {
      let criteria = this.props.criteria;
      let nights = parseInt(event.target.value, 10);
      this.props.onCriteriaChange(
          {...criteria, endDate: this.localDateToString(this.incrementDate(criteria.startDate, nights))});
      this.setState({nights: nights, endDate: this.localDateToDate(this.incrementDate(criteria.startDate, nights))});
    }
  }

  incrementDate = (dateString, noOfNights) => {
    return this.localDateFromString(dateString).plusDays(noOfNights);
  };

  localDateFromString = (dateString) => {
    return LocalDate.parse(dateString, DateTimeFormatter.ofPattern('yyyy-MM-dd'));
  };

  localDateFromDate = (date) => {
    return LocalDate.from(nativeJs(date));
  };

  localDateToString = (localDate) => {
    return localDate.format(DateTimeFormatter.ofPattern('yyyy-MM-dd'));
  };

  formatNativeDate = (date) => {
    return this.localDateToString(LocalDate.from(nativeJs(date)));
  };

  disableBeforeToday = (date) => {
    let localDate = LocalDate.from(nativeJs(date));
    return localDate.isBefore(this.state.today);
  };

  disableBeforeTodayPlusOne = (date) => {
    let localDate = this.localDateFromDate(date)
    return localDate.isBefore(this.state.tomorrow);
  };

  localDateToDate = (localDate) => {
    return convert(localDate).toDate()
  };

  styles = {
    customWidth: {
      width: 80,
    },
    calendarWith: {
      width: 150
    }
  };

  render() {
    // let criteria = this.props.criteria;
    return (
        <div className="searchBar">
          <form>
            {/*<label>Search for Rooms</label><br/>*/}
            <div className="searchBarItem">
              <DatePicker
                  name="startDate"
                  className="datePicker"
                  onChange={this.handleChangeStartDate}
                  autoOk={!!AppDimensions.renderMobile}
                  floatingLabelText="Arrival Date"
                  value={ this.localDateToDate(this.localDateFromString(this.props.criteria.startDate))}
                  disableYearSelection={this.state.disableYearSelection}
                  shouldDisableDate={this.disableBeforeToday}
                  mode={AppDimensions.renderMobile ? "portrait" : "landscape"}
                  container={AppDimensions.renderMobile ? "dialog" : "inline"}
                  textFieldStyle={this.styles.calendarWith}
              />
            </div>
            {/*<div className="searchBarItem">*/}
              {/*<TextField style={this.styles.customWidth} name="nights" floatingLabelText="Nights" floatingLabelFixed={true} value={this.state.nights}*/}
                     {/*onChange={(e) => this.handleNightsChange(e)}/>*/}
            {/*</div>*/}
            {/*<div className="searchBarItem">*/}
              {/*<DatePicker*/}
                  {/*name="endDate"*/}
                  {/*onChange={this.handleChangeEndDate}*/}
                  {/*autoOk={this.state.autoOk}*/}
                  {/*floatingLabelText="Depart Date"*/}
                  {/*value={this.state.endDate}*/}
                  {/*disableYearSelection={this.state.disableYearSelection}*/}
                  {/*shouldDisableDate={this.disableBeforeTodayPlusOne}*/}
                  {/*mode="landscape"*/}
                  {/*container="inline"*/}
                  {/*textFieldStyle={this.styles.calendarWith}*/}
              {/*/>*/}
            {/*</div>*/}
            {/*<div className="searchBarItem">*/}
              {/*<TextField name="promo_code" floatingLabelText="Promotion Code" floatingLabelFixed={true} style={this.styles.calendarWith} />*/}
            {/*</div>*/}
            {/*<div>*/}
              {/*<RoomBreakdown roomBreakdown={criteria.roomBreakdown} />*/}
            {/*</div>*/}
          </form>
        </div>
    );
  }
}

export default SearchBarComponent;


// WEBPACK FOOTER //
// ./src/components/SearchBarComponent.js